<template>
  <section v-if="bioInfoList.length > 2">
    <div v-for="(bio, index) in bioInfoList" :key="index">
      <p class="h1 info-title">{{ bio.title }}</p>
      <dl class="row">
        <div class="info-list" v-for="(info, i) in bio.infoList" :key="i">
          <dt class="col-sm-3">{{ info.property }}</dt>
          <dd class="col-sm-9">{{ info.value }}</dd>
        </div>
      </dl>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BioInfo',
  props: {
    bioInfoList: []
  }
}
</script>

<style scoped>
section {
  font-family: 'Poppins', sans-serif;
  grid-column: 3/span 2;
  grid-row: 1/span 2;
  overflow-y: scroll;
  border-left: 3px solid #7030C5;
  height: 95%;
  width: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.info-title {
  margin-bottom: 2rem;
}

.info-list {
  font-size: 1.2rem;
}

.info-list dt {
  margin-bottom: 0.8rem;
  text-align: right;
}

.info-list dd {
  overflow-wrap: break-word;
  border: lightslategrey solid 1px;
  border-radius: 2%;
}

h3 {
  font-weight: 600;
  text-transform: capitalize;
}

ul {
  list-style-type: square;
  margin-left: 2rem;
  padding: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// BioInfo.vue?09bf9c35